define("media/components/media/table/sortable-columns", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _trackMediaSort;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{yield
    (hash
      th=(component "media/table/sortable-header-cell" sortDefinition=this.sortDefinition toggleSort=this.toggleSort)
      sortedItems=this.sortedItems
    )
  }}
  */
  {
    "id": "HmbZW1vQ",
    "block": "[[[18,1,[[28,[37,1],null,[[\"th\",\"sortedItems\"],[[50,\"media/table/sortable-header-cell\",0,null,[[\"sortDefinition\",\"toggleSort\"],[[30,0,[\"sortDefinition\"]],[30,0,[\"toggleSort\"]]]]],[30,0,[\"sortedItems\"]]]]]]]],[\"&default\"],false,[\"yield\",\"hash\",\"component\"]]",
    "moduleName": "media/components/media/table/sortable-columns.hbs",
    "isStrictMode": false
  });
  let SortableColumnsComponent = _exports.default = (_dec = (0, _computed.sort)('args.data', 'sortDefinition'), (_class = (_trackMediaSort = /*#__PURE__*/new WeakSet(), class SortableColumnsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _trackMediaSort);
      _initializerDefineProperty(this, "segment", _descriptor, this);
      _initializerDefineProperty(this, "sortAscending", _descriptor2, this);
      _initializerDefineProperty(this, "sortProperty", _descriptor3, this);
      _initializerDefineProperty(this, "sortedItems", _descriptor4, this);
    }
    get sortDefinition() {
      return [`${this.sortProperty}:${this.sortAscending ? 'asc' : 'desc'}`];
    }
    toggleSort(property) {
      _classPrivateMethodGet(this, _trackMediaSort, _trackMediaSort2).call(this, property);
      if (this.sortProperty === property) {
        this.sortAscending = !this.sortAscending;
      } else {
        this.sortAscending = false;
        this.sortProperty = property;
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sortAscending", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sortProperty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'createdTime';
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sortedItems", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSort", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSort"), _class.prototype)), _class));
  function _trackMediaSort2(property) {
    this.segment.track('sorted-by-table-col', {
      group_id: this.args.currentGroup?.id || null,
      col_name: property
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SortableColumnsComponent);
});